import L, { LatLngBounds } from "leaflet";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef, useState } from "react";
import {
  FeatureGroup,
  LayersControl,
  MapContainer,
  Marker,
  Polygon,
  TileLayer,
  Tooltip,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import createCustomIcon from "./createCustomIcon";

const MapDrawMarkerComponent = (props) => {
  const mapRef = useRef(null);

  const mapHeight = props.mapHeight ?? "400px";
  const isSensorsMap = props.isSensorsMap ?? false;
  const addMarker = props.addMarker;

  const mapUrl =
    props.mapUrl ?? "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const attribution =
    props.attribution ??
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
  const { polygons = [], existingSensors = [] } = props;
  const { markerPosition, onMarkerPositionChange } = props;
  const [drawMarkerEnabled, setDrawMarkerEnabled] = useState(
    markerPosition || addMarker
  );
  let bounds;
  if (polygons && polygons.length > 0 && polygons[0]?.position) {
    bounds = new LatLngBounds(polygons[0].position);

    if (markerPosition && markerPosition.lat && markerPosition.lng) {
      bounds.extend(markerPosition);
    }
  } else if (markerPosition && markerPosition.lat && markerPosition.lng) {
    bounds = new LatLngBounds([
      [markerPosition.lat, markerPosition.lng],
      [markerPosition.lat, markerPosition.lng],
    ]);
  } else {
    bounds = new LatLngBounds([
      [36.619987291, 6.7499552751],
      [47.1153931748, 18.4802470232],
    ]);
  }

  const onCreated = (e) => {
    if (e.layerType === "marker") {
      const { lat, lng } = e.layer.getLatLng();
      const newMarkerPosition = { lat, lng };
      onMarkerPositionChange(newMarkerPosition);
      mapRef.current.removeLayer(e.layer);
      setDrawMarkerEnabled(false);
    }
  };

  const onDeleted = (e) => {
    onMarkerPositionChange(null);
    setDrawMarkerEnabled(true);
  };

  // Aggiungi l'evento `dragend` al marker per aggiornare la posizione
  const handleMarkerDragEnd = (e) => {
    const { lat, lng } = e.target.getLatLng();
    const updatedMarkerPosition = { lat, lng };
    onMarkerPositionChange(updatedMarkerPosition); // Salva la nuova posizione nel form
  };

  useEffect(() => {
    if (L.Draw && L.Draw.Marker) {
      const originalIcon = L.Draw.Marker.prototype._createMarker;
      L.Draw.Marker.prototype._createMarker = function (latlng) {
        const marker = originalIcon.call(this, latlng);

        marker.setIcon(
          createCustomIcon({
            number: " ",
            color: "blue",
          })
        );

        return marker;
      };
    }
  }, []);
  return (
    <MapContainer
      bounds={bounds}
      boundsOptions={{ padding: [50, 50] }}
      style={{ height: mapHeight }}
      ref={mapRef}
    >
      <LayersControl position="topright">
        <LayersControl.BaseLayer checked name="ArcGIS">
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution='&copy; <a href="https://www.esri.com">Esri</a> | Abinsula'
          />
        </LayersControl.BaseLayer>

        <LayersControl.BaseLayer name="OpenStreetMap">
          <TileLayer url={mapUrl} attribution={attribution} />
        </LayersControl.BaseLayer>

        <LayersControl.BaseLayer name="Opentopomap">
          <TileLayer
            url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.opentopomap.org/copyright">OpenTopoMap</a> | Abinsula'
          />
        </LayersControl.BaseLayer>
      </LayersControl>

      <FeatureGroup>
        {polygons &&
          polygons?.map((polygon) => (
            <Polygon
              key={polygon.id}
              id={polygon.id}
              positions={polygon.position}
              color={polygon.color}
            ></Polygon>
          ))}
        {/* Marker existing sensors */}
        {existingSensors?.map((sensor) =>
          sensor.position &&
          sensor.position.length === 2 &&
          !isNaN(sensor.position[0]) &&
          !isNaN(sensor.position[1]) ? (
            <Marker
              key={sensor.id}
              position={{
                lat: parseFloat(sensor.position[0]),
                lng: parseFloat(sensor.position[1]),
              }}
              icon={createCustomIcon({
                number: sensor.id_thing || "",
                color: "green",
              })}
              draggable={false}
            >
              <Tooltip
                direction="top"
                offset={[0, -10]}
                opacity={1}
                permanent={false}
              >
                {sensor.label}
              </Tooltip>
            </Marker>
          ) : null
        )}
        {markerPosition && markerPosition.lat && markerPosition.lng && (
          <Marker
            position={markerPosition}
            icon={createCustomIcon({ number: " ", color: "blue" })}
            draggable={true} // Rende il marker trascinabile
            eventHandlers={{
              dragend: handleMarkerDragEnd, // Listener per l'evento di drag
            }}
          ></Marker>
        )}

        <EditControl
          position="topright"
          onCreated={onCreated}
          onDeleted={onDeleted}
          draw={{
            rectangle: false,
            circle: false,
            marker: drawMarkerEnabled,
            polyline: false,
            circlemarker: false,
            polygon: false,
          }}
          edit={{
            edit: false,
            remove: !isSensorsMap,
          }}
        />
      </FeatureGroup>
    </MapContainer>
  );
};

export default MapDrawMarkerComponent;
